import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import { UI_MASKS } from '@/utils/uiMasks';

import {ILocationModel, ITaxRate} from '@/models/location.models';
import {FileItem, FileUploader} from 'ng2-file-upload';
import {EnvironmentService} from '@/services/EnvironmentService';
import {AuthService} from '@/services/auth.service';
import {LocationService} from '@/services/location.service';

@Component({
    selector: 'location-edit-form',
    templateUrl: './locationEditForm.template.html',
    host: {'class': 'location-edit-form-component'}
})

export class LocationEditFormComponent implements OnInit {
    @Input()
    model: ILocationModel;

    @Input()
    showAlert: boolean = false;

    @Input()
    permissionLock: boolean;

    @Output()
    onSave: EventEmitter<ILocationModel> = new EventEmitter<ILocationModel>();

    @Output()
    onGoToLocation: EventEmitter<void> = new EventEmitter<void>();

    @Output()
    onCancel: EventEmitter<void> = new EventEmitter();

    @Output()
    onRefresh: EventEmitter<void> = new EventEmitter();

    showUploader: boolean = false;

    defaultRates: Array<ITaxRate> = [
      { name: 'County', rate: 0.00 },
      { name: 'City', rate: 0.00 },
      { name: 'State', rate: 0.00 },
      { name: 'Mkecounty', rate: 0.00 },
      { name: 'Stadium', rate: 0.00 },
    ];

    uploader!: FileUploader;

    constructor(
      public uiMasks: UI_MASKS,
      public environmentService: EnvironmentService,
      public authService: AuthService,
      public locationService: LocationService) {}

    ngOnInit(): void {
      if (!this.model.useTaxRates || this.model.useTaxRates.length === 0) {
        this.model.useTaxRates = JSON.parse(JSON.stringify(this.defaultRates));
      }

      if (!this.model.taxRates || this.model.taxRates.length === 0) {
        this.model.taxRates = JSON.parse(JSON.stringify(this.defaultRates));
      }
    }

    ngOnChanges(): void {
      if (this.model.id) {
        const authToken = this.authService.accessToken.getValue();
        this.uploader = new FileUploader({
           url: this.getLogoUrl() + '?ngsw-bypass',
           authToken: 'Bearer ' + authToken,
           parametersBeforeFiles: true,
           additionalParameter: {
             maxFileSize: 10 * 1024 * 1024
           },
           removeAfterUpload: true
         });

        this.uploader.onCompleteAll = () => {
          this.uploader.clearQueue();
          this.showUploader = false;
          this.onRefresh.emit();
        };
      }
    }

    getLogoUrl(): string {
      return this.environmentService.APIBASEURL + '/locations/' + this.model.id + '/logo?ngsw-bypass=true&cacheBusting=' + Math.random();
    }

    async deleteLogo(): Promise<void> {
      await this.locationService.deleteLogo(this.model.id);
      this.onRefresh.emit();
    }

    saveLocation(): void {
        this.onSave.emit(this.model);
    }

    goToLocation(): void {
        this.onGoToLocation.emit(null);
    }

    getOrderedTaxRates(taxRates: Array<ITaxRate>): Array<ITaxRate> {
      if (!taxRates.length) return [];
      return [
        taxRates.find(rate => rate.name === 'County'),
        taxRates.find(rate => rate.name === 'Mkecounty'),
        taxRates.find(rate => rate.name === 'State'),
        taxRates.find(rate => rate.name === 'City'),
        taxRates.find(rate => rate.name === 'Stadium')
      ];
    }

    updateRate(e: any, rate: ITaxRate): void {
      rate.rate = e / 100;
    }

    cancel(): void {
        this.onCancel.emit(null);
    }

    onFileSelected(e: File[]): void {
      this.uploader.addToQueue([e[0]]);
      this.uploader.uploadAll();
    }
}
